<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top" @click="onAdd()">
        <div class="flex-1 font-16-30313a">成本核算分组</div>
        <div class="tip-20-bg-30313a">
          <i class="el-icon-plus font-bold"></i>
        </div>
      </div>
      <el-scrollbar class="hide-x h-100">
        <div  id="cateMenu">
          <div v-for="(item, index) in menuList" :key="index" class="menu-item" :class="{'is-active': chooseMenuIndex === index}">
            <div class="flex align-center pl-20 menu-body" @click="onChooseMenu(item, index)">
              <div class="index-tip">{{index + 1}}</div>
              <div class="menu-title-big">{{item.name}}</div>
              <div class="btn-container align-center">
                <i class="el-icon-edit mr-5" @click.stop="onEdit(item)"></i>
                <i class="el-icon-circle-close" @click.stop="onDelete(item)"></i>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0 ptb-10 mlr-10">
      <div class="flex content-top">
        <div class="flex-1 bg-ff h-100 flex align-center">
          <div class="flex align-center ml-5 mr-20 cursor">
            <div class="mr-5 decoration-line" ></div>
            <div class="font-bold font-16-f5971d" v-if="projectClassify">{{projectClassify.name}}</div>
          </div>
          <!--<div class="flex align-center mr-5 btn-24-bd-e2-bg-ff" @click="addProjectDetail">-->
            <!--<img src="/static/images/cundang.png" class="icon-14 mr-5" alt="">-->
            <!--<div>保存</div>-->
          <!--</div>-->
        </div>
      </div>
      <div class="mt-10 mb-5 flex flex-wrap">
        <div class="flex align-center mr-5 mb-5 btn-24-bg-ff" @click="addProjectDetail">
          <img src="/static/images/add.png" class="icon-14 mr-5" alt="">
          <div>添加</div>
        </div>
        <div class="flex align-center mr-5 mb-5 btn-24-bg-ff"  @click="deleteProjectDetail">
          <img src="/static/images/shanchu.png" class="icon-12-14 mr-5" alt="">
          <div>删除</div>
        </div>
      </div>
      <div style="height: 600px">
        <erp-table ref="erpTable" :is-edit="true" :table-data="tableData" :loading="loading" :column-data="columnData" @on-change="onChange" @on-modify="onModifyRow" modify-method="on-modify"></erp-table>
      </div>
    </div>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="500px" title="工程进度模板" :visible.sync="modelShow" @closed="onCloseClassify">
      <div class="p-20">
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">分组名称：</div>
          <el-input v-model="newClassify.name" class="flex-1" placeholder="请输入分组名称"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseClassify">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="onSubmitClassify">确定</div>
      </div>
    </el-dialog>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="500px" title="添加分组详情" :visible.sync="modelDetailShow" @closed="onCloseDetail">
      <div class="p-20">
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">名称：</div>
          <el-input v-model="modelDetail.name" class="flex-1" placeholder="请输入名称"></el-input>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">公式：</div>
          <el-input v-model="modelDetail.formulaCompute" class="flex-1" placeholder="请输入名称"></el-input>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">是否修改：</div>
          <div class="flex  align-center ">
            <el-switch
              v-model="modelDetail.isModified"
              active-color="#13ce66"
              inactive-color="#f3f4f7">
            </el-switch>
          </div>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">代码：</div>
          <el-input v-model="modelDetail.specialItem" class="flex-1" placeholder="请输入工序"></el-input>
        </div>
        <div class="flex mb-10">
          <div class="font-12-30313a mr-5">说明：</div>
          <el-input type="textarea" v-model="modelDetail.description" :row="3" class="flex-1" placeholder="请输入备注"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseDetail">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="onSubmitDetail">确定</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import MoveHorizon from '../../../components/MoveHorizon'
import ErpTable from '../../../components/ErpTable'
export default {
  name: 'projectProgressDefine',
  components: {MoveHorizon, ErpTable},
  data () {
    return {
      chooseMenuIndex: 0,
      projectClassify: {},
      loading: false,
      menuList: [],
      columnData: [
        {
          type: 'selection',
          width: '40',
          fixed: 'left'
        },
        {
          field: 'sort',
          title: '序号',
          width: '60',
          fixed: 'left',
          editRender: {
            name: 'input'
          }
        },
        {
          field: 'specialItem',
          title: '代码',
          width: '100',
          editRender: { // 开启该列可编辑
            name: 'input' // input/select/textarea
          }
        },
        {
          field: 'isModified',
          title: '填写',
          width: '70',
          isDefine: true,
          child: [{
            title: '是',
            key: 'isModified',
            methodName: 'on-change',
            type: 'radio',
            activeValue: 1,
            inactiveValue: -1
          }]
        },
        {
          field: 'name',
          title: '项目内容',
          minWidth: '160',
          editRender: {
            name: 'input'
          }
        },
        {
          field: 'formulaCompute',
          title: '计算公式',
          minWidth: '160',
          editRender: {
            name: 'input'
          }
        },
        {
          field: 'description',
          title: '说明',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }
      ],
      tableData: [],
      modelShow: false,
      standardShow: false,
      modelDetailShow: false,
      newClassify: {
        name: ''
      },
      editItem: {},
      modelDetail: {
        name: '',
        formulaCompute: '',
        isModified: true,
        specialItem: '',
        description: ''
      }
    }
  },
  created () {
    this.getTemplate()
  },
  mounted () {},
  methods: {
    getTemplate () {
      let params = {
        companyId: this.$store.state.companyId
      }
      this.axios.post('contractTemplate/list', params).then(res => {
        if (res.data.success) {
          this.menuList = res.data.data
          this.projectClassify = this.menuList[0]
          this.getTemplateDetail()
        }
      })
    },
    getTemplateDetail () {
      let params = {
        contractId: this.projectClassify.id
      }
      this.axios.post('contractItemTemplate/list', params).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data
        }
      })
    },
    onAdd () {
      this.modelShow = true
    },
    onChooseMenu (menu, index) {
      this.projectClassify = menu
      this.chooseMenuIndex = index
      this.getTemplateDetail()
    },
    onEdit (item) {
      this.newClassify.name = item.name
      this.editItem = item
      this.modelShow = true
    },
    onDelete (item) { // 删除分组
      let params = {
        id: item.id
      }
      this.axios.post('contractTemplate/deleteById', this.qs.stringify(params)).then(res => {
        if (res.data.success) {
          this.$message({
            message: '删除分组成功',
            type: 'success'
          })
          this.modelShow = false
          this.getTemplate()
        }
      })
    },
    onEnable (row) {
      let params = {
        id: row.id
      }
      this.axios.post('contractTemplate/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.modelShow = false
          this.getTemplate()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChange (row) {
      this.onModifyRow(row)
    },
    onSubmitClassify () {
      if (JSON.stringify(this.editItem) === '{}') {
        this.saveSub()
      } else {
        this.editSub()
      }
    },
    saveSub () { // 新增分组
      let params = {
        name: this.newClassify.name,
        companyId: this.$store.state.companyId
      }
      if (this.newClassify.name) {
        this.axios.post('contractTemplate/save', params).then(res => {
          if (res.data.success) {
            this.$message({
              message: '添加分组成功',
              type: 'success'
            })
            this.modelShow = false
            this.getTemplate()
            this.newClassify.name = ''
          }
        })
      } else {
        this.$message.error('分组名称不能为空哟')
      }
    },
    editSub () { // 编辑
      let params = {
        id: this.editItem.id,
        name: this.newClassify.name
      }
      this.axios.post('contractTemplate/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.modelShow = false
          this.getTemplate()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onSubmitDetail () { // 新增分组详情
      this.modelDetail.contractId = this.projectClassify.id
      if (this.modelDetail.isModified) {
        this.modelDetail.isModified = 1
      } else {
        this.modelDetail.isModified = -1
      }
      this.axios.post('contractItemTemplate/save', this.modelDetail).then(res => {
        if (res.data.success) {
          this.modelDetailShow = false
          this.getTemplateDetail()
          this.$message({
            message: '添加分组详情成功',
            type: 'success'
          })
          this.modelDetail = {}
        }
      })
    },
    addProjectDetail () {
      this.modelDetailShow = true
    },
    deleteProjectDetail () {
      let customerArr = this.$refs.erpTable.getSelectEvent()
      if (customerArr.length === 0) {
        this.$message({
          message: `请先选择一个分组列表`,
          type: 'warning'
        })
      } else {
        console.log(customerArr)
        let idArr = []
        for (let i = 0; i < customerArr.length; i++) {
          idArr.push(customerArr[i].id)
        }
        let params = {
          ids: idArr.join(',')
        }
        this.axios.post('contractItemTemplate/deleteByIds', this.qs.stringify(params)).then(res => {
          if (res.data.success) {
            this.getTemplateDetail()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
          }
        })
      }
    },
    onModifyRow (row) {
      let params = null
      if (row) {
        params = {
          id: row.id,
          name: row.name,
          sort: row.sort,
          formulaCompute: row.formulaCompute,
          isModified: row.isModified,
          specialItem: row.specialItem,
          description: row.description
        }
      }
      this.axios.post('contractItemTemplate/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.getTemplateDetail()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onCloseClassify () {
      this.modelShow = false
      this.newClassify = {}
    },
    onCloseDetail () {
      this.modelDetailShow = false
      this.modelDetail = {}
    }
  }
}
</script>

<style lang="scss" scoped>
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .dialog-left-top {
    height: 40px;
    border-bottom: 1px solid #e2e2e2;
    line-height: 40px;
    padding: 0 20px;
    font-size: 16px;
    color: #30313a;
    text-align: left;
    background-color: #ffffff;
  }
  .dialog-menu-item {
    height: 35px;
    line-height: 35px;
    display: flex;
    padding: 0 20px;
    font-size: 12px;
    color: #30313a;
    text-align: left;
    cursor: pointer;
    &.active {
      color: #f5971d;
    }
    &.current {
      color: #f5971d;
      background: #f3f4f7;
    }
  }
  .hide-x {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  }
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      line-height: 30px;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #f5971d;
      }
    }
  }
  #cateMenu {
    height: 100%;
    width: 100%;
    min-width: 200px;
    background: #fff;
    overflow-y: auto;
    .menu-item {
      min-height: 35px;
      border-bottom: dashed 1px #e2e2e2;
      line-height: 35px;
      .index-tip {
        width: 20px;
        text-align: center;
        height: 14px;
        line-height: 14px;
        background-color: #b9b9b9;
        border-radius: 4px;
        font-size: 10px;
        color: #ffffff;
        margin-right: 5px;
      }
      .menu-title-big {
        flex: 1;
        overflow-x: hidden;
        font-size: 14px;
        color: #30313a;
        word-break: keep-all;
        text-align: left;
      }
      .btn-container {
        padding: 0 10px;
        display: flex;
        align-items: center;
        i {
          font-size: 14px;
          color: #e2e2e2;
        }
      }
      &.is-open{
        background-color: #f3f4f7;
        .index-tip {
          background-color: #f5971d;
        }
        .menu-title-big {
          color: #f5971d;
        }
      }
      &.is-active{
        .menu-body {
          color: #f5971d;
        }
        .index-tip {
          background-color: #f5971d;
          color: #ffffff;
        }
        .menu-title-big {
          color: #f5971d;
        }
      }
      .menu-body:hover, &.is-active .menu-body {
        cursor: pointer;
        .btn-container {
          i {
            color: #30313a;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/component/costAccountingUnit.vue